<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}"
            :width="$vuetify.breakpoint.lgAndUp ? 1134 : 'auto'"
    >
        <v-form @submit.prevent>
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('add_user')" aria-hidden="true" translate="no">close</v-icon>
            <v-card-title class="display-1 mb-4">{{ $t("Добавить нового пользователя") }}</v-card-title>
            <v-layout mb-4 wrap align-center>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Фамилия") }} *</div>
                    <inputBase v-model="surname_change" :placeholder="$t('Введите фамилию')"
                               :class="{ 'form-group--error': !$v.surname.alpha || !$v.surname.required && $v.surname.$dirty }"
                    />
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Имя") }} *</div>
                    <inputBase v-model="username_change" :placeholder="$t('Введите имя')"
                               :class="{ 'form-group--error': !$v.username.alpha || !$v.username.required && $v.username.$dirty }"
                    />
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.sm}"
                >
                    <div class="grey-text mb-2">{{ $t("Отчество") }} {{ org_iso === 'RU' ? ' *' : '' }}</div>
                    <inputBase v-model="patr_change" :placeholder="$t('Введите отчество')"
                               :class="{'form-group--error': $v.patr.$error}"
                    />
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">E-mail *</div>
                    <inputBase v-model="email_change" :placeholder="$t('Введите e-mail') " type="text"
                               :class="{ 'form-group--error': !$v.email.email || !$v.email.required && $v.email.$dirty }"
                    />
                    <div v-if="email_exist" class="error">{{ $t('Такой E-mail уже зарегистрирован') }}</div>
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-4 :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Должность") }} *</div>
                    <inputBase v-model="position_change" :placeholder="$t('Введите должность')"
                               :class="{ 'form-group--error': !$v.position.required && $v.position.$dirty }"
                    />
                </v-flex>
                <v-flex md4 sm6 xs12
                        mb-0 :class="{'mb-4': $vuetify.breakpoint.xs}"
                >
                    <checkbox v-model="is_internal" v-if="!user.external" id="internal"
                              :checked="internal_user"
                    >{{ $t("Внутренний пользователь") }}
                    </checkbox>
                </v-flex>
                <v-flex v-if="internal_user" md4 sm6
                        xs12 mb-4 :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Управление") }} *</div>
                    <v-select
                        v-model.trim="$v.depart.$model"
                        :items="users_form.departments"
                        solo
                        attach="js-depart"
                        append-icon=""
                        :label="$t('Выберите отдел')"
                        class="input js-depart"
                        :class="{ 'form-group--error': !$v.depart.required && $v.depart.$dirty }"
                        @change="set_department($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <v-flex v-if="!internal_user" md4 sm6
                        xs12 mb-4 :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Организация") }} *</div>
                    <v-autocomplete
                        v-model.trim="$v.org.$model"
                        :disabled="org_disabled"
                        :items="organizations_search"
                        item-text="text"
                        item-value="id"
                        solo
                        attach="js-org"
                        append-icon=""
                        :label="$t('Выберите организацию')"
                        class="input js-org input-text-overflow"
                        :class="{ 'form-group--error': !$v.org.required && $v.org.$dirty }"
                        @change="set_organization($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-autocomplete>
                </v-flex>
                <!-- <v-flex v-if="!internal_user" md4 sm6
                        xs12 mb-4 :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <div class="grey-text mb-2">{{ $t("Специализация") }} *</div>
                    <v-select
                        v-model.trim="$v.spec.$model"
                        :items="users_form.specializations"
                        solo
                        attach="js-spec"
                        append-icon="expand_more"
                        label="$t('Выберите специализацию')"
                        class="input js-spec"
                        :class="{ 'form-group--error': !$v.spec.required && $v.spec.$dirty }"
                        @change="set_specialization($event)"
                    />
                </v-flex> -->
                <v-flex md4 sm6 xs12
                        pr-4
                        mb-4 :class="{'pr-4': $vuetify.breakpoint.mdAndUp && internal_user, }"
                >
                    <div class="grey-text mb-2">{{ $t("Роль") }} *</div>
                    <v-select
                        v-model.trim="$v.role.$model"
                        :disabled="role_disabled"
                        :items="users_form.roles"
                        solo
                        attach="js-role"
                        append-icon=""
                        :label="$t('Выберите роль')"
                        class="input js-role"
                        :class="{ 'form-group--error': !$v.role.required && $v.role.$dirty }"
                        @change="set_role($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <v-flex md4 sm6 mb-4 />
            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="send_new_user(new_user)">
                        {{ $t("Добавить") }}
                    </buttonRed>
                    <div class="grey-text"
                         :class="{'ml-4': $vuetify.breakpoint.smAndUp, 'mt-2': $vuetify.breakpoint.xs}"
                    >{{ $t('* - поля, обязательные для заполнения') }}
                    </div>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import inputBase from '@/components/ui/inputs/base/input';
import checkbox from '@/components/ui/inputs/base/checkbox.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import {required, helpers, requiredIf, email} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import {RESPONSIBLE_PERSON, REPLACEMENT_PERSON} from '@/configs/roles';
import Checkbox from '@inputs/base/checkbox.vue';

const alpha = helpers.regex('alpha', /^[ЁёА-яa-zA-Z\-\s]+$/);

const optionalPatronymic = (param) =>
  (value) => param !== 'RU' || (helpers.req(value) && alpha(value));

export default {
  components: {
    buttonRed,
    inputBase,
    checkbox,
    Checkbox,
  },
  mixins: [validationMixin],
  validations() {
    return {
      username: {
        required,
        alpha,
      },
      surname: {
        required,
        alpha,
      },
      patr: {
        optionalPatronymic: optionalPatronymic(this.org_iso),
      },
      email: {
        required,
        email,
      },
      position: {
        required,
        email,
      },
      org: {
        required: requiredIf(function(model) {
          return !this.is_internal && model;
        }),
      },
      // spec: {
      //   required: requiredIf(function(model) {
      //     return !this.is_internal && model;
      //   }),
      // },
      role: {
        required,
      },
      depart: {
        required: requiredIf(function(model) {
          return this.is_internal && model;
        }),
      },
    };
  },
  data() {
    return {
      email_exist  : false,
      username     : '',
      surname      : '',
      patr         : '',
      email        : '',
      position     : '',
      org          : '',
      org_disabled : false,
      spec         : '',
      role         : '',
      role_disabled: false,
      depart       : '',
      new_user     : {
        'name'          : '',
        'last_name'     : '',
        'patronymic'    : '',
        'email'         : '',
        'position'      : '',
        'external'      : true,
        'department'    : 0,
        'role'          : 0,
        'organization'  : 0,
        'specialization': '0',
      },
      errors : false,
      org_iso: '',
    };
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('users/modals', [
      'add_user',
      'add_organization',
      'internal_user',
      'users_form',
    ]),
    ...mapGetters('users/employees', [
      'organizations',
      'roles',
      'specialities',
      'departments',
    ]),
    organizations_search() {
      return this.users_form.organizations.map((i) => i.text);
    },
    surname_change: {
      get() {
        return this.surname;
      },
      set($event) {
        this.new_user.last_name = $event.target.value;
        this.surname = $event.target.value;
        this.$v.surname.$touch();
      },
    },
    username_change: {
      get() {
        return this.username;
      },
      set($event) {
        this.new_user.name = $event.target.value;
        this.username = $event.target.value;
        this.$v.username.$touch();
      },
    },
    patr_change: {
      get() {
        return this.patr;
      },
      set($event) {
        this.new_user.patronymic = $event.target.value;
        this.patr = $event.target.value;
        this.$v.patr.$touch();
      },
    },
    email_change: {
      get() {
        return this.email;
      },
      set($event) {
        this.new_user.email = $event.target.value.trim();
        this.email_exist = false;
        this.email = $event.target.value.trim();
        this.$v.email.$touch();
      },
    },
    position_change: {
      get() {
        return this.position;
      },
      set($event) {
        this.new_user.position = $event.target.value;
        this.position = $event.target.value;
        this.$v.position.$touch();
      },
    },
    is_internal: {
      get() {
        return this.internal_user;
      },
      set($event) {
        this.external = !$event.target.checked;
        return this.SET_INTERNAL_USER($event.target.checked);
      },
    },
  },
  async mounted() {
    await this.get_users_form();

    if ([REPLACEMENT_PERSON, RESPONSIBLE_PERSON].includes(this.user.role_code)) {
      const organizations = this.users_form.organizations;

      if (organizations && organizations.length > 0) {
        const org = organizations[0];

        this.new_user.organization = org.id;
        this.org_iso = org.country_iso;
        this.org = org.text;
        this.org_disabled = true;
      }

      const roles = this.users_form.roles;

      if (roles && roles.length > 0) {
        const role = roles[0];
        this.new_user.role = role.id;
        this.role = role.text;
        this.role_disabled = true;
      }
    }
  },
  methods: {
    check_access() {
      this.catalog_access = !this.catalog_access;
      this.new_user.catalog_access = this.catalog_access;
    },
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
      'SET_INTERNAL_USER',
    ]),
    ...mapActions('users/modals', [
      'get_users_form',
      'get_companies_form',
    ]),
    ...mapActions('users/requests', [
      'add_new_request',
      'get_users_requests',
    ]),
    ...mapActions('users/employees', [
      'add_new_user',
      'accept_new_user',
      'update_users',
    ]),
    set_organization(ev) {
      this.$v.org.$touch();
      if (this.users_form.organizations) {
        let org = this.users_form.organizations.find((item) => item.text == ev);

        this.new_user.organization = org.id;
        this.org_iso = org.country_iso;
      }
    },
    // set_specialization(ev) {
    //   this.$v.spec.$touch();
    //   if (this.users_form.specializations) {
    //     this.new_user.specialization = Number(this.users_form.specializations.find((item)=>item.text == ev).id);
    //   }
    // },
    set_role(ev) {
      this.$v.role.$touch();
      this.new_user.role = Number(this.users_form.roles.find((item) => item.text == ev).id);
    },
    set_department(ev) {
      this.$v.depart.$touch();
      if (this.internal_user && this.users_form.departments) {
        this.new_user.department = Number(this.users_form.departments.find((item) => item.text == ev).id);
      }
    },
    async send_new_user(user) {
      this.$v.$touch();

      setTimeout(async () => {
        if (document.querySelector('.form-group--error')) {
          this.errors = true;
        } else {
          this.errors = false;
          try {
            if (this.user.external) {
              await this.add_new_user(this.new_user);
              await this.add_new_request({request: this.new_user, type: 'user'});
            } else {
              await this.add_new_user(this.new_user);
              await this.accept_new_user(this.new_user);
            }

            let obj = {
              page_size: 10,
              page_num : 1,
              by       : '',
              order    : '',
            };

            await this.update_users();
            await this.get_users_requests(obj);
            this.CLOSE_MODAL('add_user');
          } catch (error) {
            if (error === 'email exist') {
              this.email_exist = true;
            }
          }
        }
      }, 100);
    },
  },
};
</script>
